
import { mapState } from "vuex";
// import Benchmark from "../components/Benchmark.vue";
// import Event from "../components/InteractiveComponents/Event.vue";
// import ListVideoHomePage from "../components/InteractiveComponents/ListVideoHomePage.vue";
// import SearchInformation from "../components/InteractiveComponents/SearchInformation.vue";
import SearchSchool from "../components/InteractiveComponents/SearchSchool.vue";
// import YourSchool from "../components/InteractiveComponents/YourSchool.vue";
// import Qna from "../components/Qna.vue";
// import Tuition from "../components/Tuition.vue";
// import WrapComponents from "../components/WrapComponents.vue";
import lazyLoadComponent from "../utils/lazyLoadComponent";
import Axios from "axios";
import { AxiosClient } from "../utils/axios";
export default {
  name: "Home",
  layout: "root",
  components: {
    WrapComponents: () => import("../components/WrapComponents.vue"),
    Section: () => import("../components/Section.vue"),
    Card: () => import("../components/Card.vue"),
    Row: () => import("../components/Row.vue"),
    Col: () => import("../components/Col.vue"),
    YourSchool: () =>
      import("../components/InteractiveComponents/YourSchool.vue"),
    ListVideoHomePage: () =>
      import("../components/InteractiveComponents/ListVideoHomePage.vue"),
    Event: () => import("../components/InteractiveComponents/Event.vue"),
    EventNews: () =>
      import("../components/InteractiveComponents/EventNews.vue"),
    SearchInformation: () =>
      import("../components/InteractiveComponents/SearchInformation.vue"),
    Qna: () => import("../components/Qna.vue"),
    SearchSchoolBanner: () => import("../components/SearchSchoolBanner.vue"),
    Benchmark: () => import("../components/Benchmark.vue"),
    Tuition: () => import("../components/Tuition.vue"),
  },
  head: {
    meta: [
      { charset: "utf-8" },
      {
        hid: "description",
        name: "description",
        content:
          "Nơi chia sẻ thông tin và cập nhật tin tức, tra cứu điểm thi tuyển sinh đại học, cao đẳng tại Việt Nam",
      },
    ],
  },

  computed: {
    ...mapState("Event", ["newestEventData", "newestEventLoading"]),
  },
  data() {
    return {
      BASE_URL_STATIC: this.$config.BASE_URL_STATIC,
      loading: {
        bannerTarget: true,
        yourSchoolTarget: true,
        searchSchoolTarget: true,
        tuitionTarget: true,
        benchmarkTarget: true,
        searchInfoTarget: true,
        listTarget: true,
        qnaTarget: true,
        eventTarget: true,
      },
    };
  },
  async mounted() {
    await this.testVerifyToken();

    this.$store.dispatch("Event/getListNewestEvent", { location: "" });

    // Create an Intersection Observer instance
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // Check if the target element is in the viewport
          if (entry.isIntersecting) {
            // Load the lazy component when it's visible
            // this.lazyComponentLoaded = true;
            // observer.disconnect(); // Disconnect the observer to stop watching

            if (this.loading[entry.target.id]) {
              this.loading[entry.target.id] = false;
            }
            this.$refs[entry.target.id].style.height = "auto";
            observer.unobserve(entry.target);
          }
        });
      },
      {
        root: null, // Use the viewport as the root
        rootMargin: "0px", // No margin
        threshold: 0.2, // Trigger when at least 1% of the target is visible
      },
    );
    // console.log(this.$refs.test)
    // Start observing the target element
    console.log(this.$refs.bannerTarget);
    // Helper function to safely observe an element
    const safeObserve = (element) => {
      if (element && element instanceof Element) {
        observer.observe(element);
      }
    };

    safeObserve(this.$refs.bannerTarget);
    safeObserve(this.$refs.yourSchoolTarget);
    safeObserve(this.$refs.searchSchoolTarget);
    safeObserve(this.$refs.tuitionTarget);
    safeObserve(this.$refs.benchmarkTarget);
    safeObserve(this.$refs.searchInfoTarget);
    safeObserve(this.$refs.listTarget);
    safeObserve(this.$refs.eventTarget);
    safeObserve(this.$refs.qnaTarget);
  },
  methods: {
    handleFilterEventChange(province) {
      this.$store.dispatch("Event/getListNewestEvent", {
        location: province.name || "",
      });
    },
    handleFilterEventChangeNewEvents(province) {
      this.$store.dispatch("Event/getListNewestEventEducation", {});
    },
    async testVerifyToken() {
      try {
        const domain = this.$config.BASE_URL_CLIENT;
        const response = await Axios.get(
          `${domain}/api/event/get-list-newest-event?location=`,
        );
        // const response = await AxiosClient.get(`/api/event/get-list-newest-event?location=`)
        console.log({ response: response.data });
      } catch (error) {
        console.log({ error });
      }
    },
  },
};
